export function SkeletonBar({ className = "" }: { className?: string }) {
  return <div className={`bg-grove-200 rounded animate-pulse ${className}`} />;
}

export function SkeletonCard() {
  return (
    <div className="bg-white rounded-xl border border-grove-300 p-6">
      <SkeletonBar className="h-4 w-1/3 mb-4" />
      <SkeletonBar className="h-8 w-2/3 mb-2" />
      <SkeletonBar className="h-3 w-1/2" />
    </div>
  );
}

export function SkeletonTable({ rows = 5, cols = 6 }: { rows?: number; cols?: number }) {
  return (
    <div className="bg-white rounded-xl border border-grove-300 overflow-hidden">
      <div className="p-4 border-b border-grove-200">
        <SkeletonBar className="h-4 w-1/4" />
      </div>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex gap-4 px-4 py-3 border-b border-grove-100">
          {Array.from({ length: cols }).map((_, j) => (
            <SkeletonBar key={j} className="h-4 flex-1" />
          ))}
        </div>
      ))}
    </div>
  );
}
